@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/graphics-panel/mam-graphic-params-editor/clipping-studio-mam-graphic-params-editor.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: block;
}
.mam-gfx-params {
  --cs-gfx-compact-control-width: 140px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.mam-gfx-params__category {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: stretch;
}
.mam-gfx-params__label {
  font-family: "Open Sans", sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.35);
  text-transform: uppercase;
}
.mam-gfx-params__sub {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  text-transform: uppercase;
  margin-bottom: 4px;
}
.mam-gfx-params__hint {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  margin-bottom: 6px;
}
.mam-gfx-params__duration-field {
  width: var(--cs-gfx-compact-control-width);
  align-self: flex-start;
  box-sizing: border-box;
}
.mam-gfx-params__duration-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
}
.mam-gfx-params__duration-input {
  text-align: end;
  width: 100%;
  max-width: 100%;
  height: 28px;
  box-sizing: border-box;
  border: 1px solid #e1e6eb;
  border-radius: 6px;
  padding-left: 18px;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  background: rgb(255, 255, 255);
}
.mam-gfx-params__duration-input:focus-visible {
  border: 1px solid #e1e6eb;
  border-radius: 6px;
  outline: none;
}
.mam-gfx-params__duration-suffix {
  position: absolute;
  display: flex;
  height: fit-content;
  margin: 0 !important;
  align-items: center;
  margin-left: 6px !important;
  font-size: 12px;
  letter-spacing: 0.1px;
  color: #7d8fa1;
  pointer-events: none;
  line-height: 1;
}
.mam-gfx-params__block {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.mam-gfx-params__textarea,
.mam-gfx-params__input {
  width: 100%;
  box-sizing: border-box;
  font-family: "Open Sans", sans-serif;
  font-size: 13px;
  padding: 8px 10px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  background: rgb(255, 255, 255);
}
.mam-gfx-params__textarea:focus,
.mam-gfx-params__input:focus {
  outline: none;
  border-color: rgb(45, 187, 252);
}
.mam-gfx-params__textarea {
  resize: vertical;
  min-height: 56px;
}
.mam-gfx-params__row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}
.mam-gfx-params__row--checkbox label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
}
.mam-gfx-params__layer-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: var(--cs-gfx-compact-control-width);
  align-self: flex-start;
  min-width: 0;
  box-sizing: border-box;
}
.mam-gfx-params__layer-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  width: 100%;
}
.mam-gfx-params__layer-row ::ng-deep evrideo-layer-input {
  display: block;
  width: 100%;
  max-width: 100%;
}
.mam-gfx-params__layer-row ::ng-deep .layer-text {
  display: none !important;
}
.mam-gfx-params__layer-row ::ng-deep .tooltip {
  display: none !important;
}
.mam-gfx-params__layer-row ::ng-deep .layers {
  width: 100% !important;
  max-width: 100%;
}
.mam-gfx-params__layer-row ::ng-deep .container {
  width: 100%;
  max-width: 100%;
}
.mam-gfx-params__layer-row ::ng-deep .layer-input-warpper {
  width: var(--cs-gfx-compact-control-width);
  min-width: var(--cs-gfx-compact-control-width);
  max-width: var(--cs-gfx-compact-control-width);
  flex: 0 0 var(--cs-gfx-compact-control-width);
  box-sizing: border-box;
}
.mam-gfx-params__layer-row ::ng-deep .layer-input {
  width: var(--cs-gfx-compact-control-width);
  max-width: var(--cs-gfx-compact-control-width);
  box-sizing: border-box;
  border-radius: 6px;
}
.mam-gfx-scale {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
  min-width: 0;
}
.mam-gfx-scale__row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  min-width: 0;
}
.mam-gfx-scale__slider {
  flex: 1;
  min-width: 0;
  height: 8px;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  border: none;
  outline: none;
}
.mam-gfx-scale__slider::-webkit-slider-runnable-track {
  height: 4px;
  background: #e1e6eb;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 2px;
}
.mam-gfx-scale__slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgb(45, 187, 252);
  border: 2px solid rgb(255, 255, 255);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.14);
  cursor: pointer;
  margin-top: -6px;
}
.mam-gfx-scale__slider::-moz-range-track {
  height: 4px;
  background: #e1e6eb;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 2px;
}
.mam-gfx-scale__slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgb(45, 187, 252);
  border: 2px solid rgb(255, 255, 255);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.14);
  cursor: pointer;
}
.mam-gfx-scale__number {
  width: 70px;
  padding: 6px 6px;
  font-size: 12px;
  font-family: "Open Sans", sans-serif;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 6px;
  box-sizing: border-box;
}
.mam-gfx-params__media-card {
  padding: 4px 0 8px;
}
.mam-gfx-params__media-title {
  font-size: 12px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 8px;
}
/*# sourceMappingURL=clipping-studio-mam-graphic-params-editor.component.css.map */
